import { Dialog } from 'Dialog';
import { DialogTitle } from 'DialogTitle';
import { styled } from 'helpers';
import { FormControlLabel } from 'FormControlLabel';

export const StyledDialog = styled(Dialog)`
  & .MuiPaper-root {
    padding-top: 32px;
    padding-bottom: 32px;
    border-radius: 8px;
    box-shadow: 0px 0px 8px rgba(34, 38, 72, 0.16);
  }

  /* Create a left margin on the Confirm button if a Cancel button is present */
  & .MuiDialogActions-root > :not(:first-of-type) {
    margin-left: 16px;
  }
`;

export const StyledDialogTitle = styled(DialogTitle)`
  margin-bottom: 24px;
`;

export const StyledFormControlLabel = styled(FormControlLabel)`
  margin-bottom: 24px;
  margin-left: 0;
  color: ${({ theme }) => theme.palette.blueGrey.A600};

  & .MuiTypography-root.MuiFormControlLabel-label {
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
    letter-spacing: 0.25px;
    line-height: ${20 / 14};
    margin-left: 8px;
  }
`;
